<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'AideMemoire',

    metaInfo: { title: 'Aide-mémoire' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'aide-memoire',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'aide-memoire',
      },
    },
  }
</script>
